import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-b3e7a9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-apply-index-closed-header" }
const _hoisted_4 = { class: "p-apply-index-closed-header_inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-apply-index-closed-header_hl" }, "選考終了一覧", -1))
const _hoisted_6 = {
  key: 0,
  class: "p-apply-index"
}
const _hoisted_7 = { class: "p-apply-index-wp" }
const _hoisted_8 = {
  key: 0,
  class: "p-apply-index-list"
}
const _hoisted_9 = { class: "p-jobsearch-list_more" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "l-wrapper_nav" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { getApplyClosedListService } from '@/api/services/shintyokuService';
import ApplyListItem from '@/components/ApplyListItem.vue';
import Loading from '@/components/Loading.vue';
import { Apply } from '@/types';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { onActivated, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';
import { useStore } from 'vuex';
// ダミーデータ

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyClosedView',
  setup(__props) {

const applyList = ref<Array<Apply>>([]);
const totalCount = ref(0);
const isLoading = ref(false);
const isLoadingMore = ref(false);
const isJobListLoaded = ref(false);

const hasMore = ref(false);
const shintyokuSelectParams = ref<TrnShintyokuSelectRequest>({});

async function loadApplyClosedList(params?: TrnShintyokuSelectRequest, isLoadMore = false) {
  try {
    const requestParams: TrnShintyokuSelectRequest = {
      ...shintyokuSelectParams.value,
      ...(params || {}),
    };

    const applyData = await getApplyClosedListService(requestParams);
    const fetchedJobs = applyData.shintyokuList;
    if (fetchedJobs && fetchedJobs.length > 0) {
      if (!isLoadMore) {
        applyList.value = fetchedJobs;
      } else {
        applyList.value = [...applyList.value, ...fetchedJobs];
      }
    }
    totalCount.value = applyData.totalCount;
    shintyokuSelectParams.value.pageCursor = applyData.pageCursor;
    hasMore.value = applyData.hasMore;
    isJobListLoaded.value = true;
  } catch (error) {
    console.error(error);
  }
}

async function nextPage() {
  if (applyList.value.length < totalCount.value) {
    isLoadingMore.value = true;
    await loadApplyClosedList({}, true);
    isLoadingMore.value = false;
  }
}

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const route = useRoute();
const store = useStore();
onActivated(async () => {
  isLoading.value = true;

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    isLoading.value = false;
    await store.dispatch('favorites/clearFavorite');
    return;
  }

  // Reset ref before set new value
  resetRefs();

  await loadApplyClosedList();
  isLoading.value = false;
});

const resetRefs = () => {
  shintyokuSelectParams.value = {};
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", null, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_unref(RouterLink), {
                  class: "p-apply-index-closed-header_back",
                  to: { name: 'n00' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("戻る")
                  ]),
                  _: 1
                })
              ])
            ]),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (applyList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyList.value, (apply) => {
                            return (_openBlock(), _createBlock(ApplyListItem, {
                              key: apply.orderId,
                              apply: apply
                            }, null, 8, ["apply"]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_9, [
                            (applyList.value.length < totalCount.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "p-jobsearch-btn __blue __more",
                                  disabled: isLoadingMore.value,
                                  onClick: nextPage
                                }, [
                                  _createTextVNode(" 検索結果をもっと見る "),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["p-jobsearch-btn_ico", { 'loading-spinner': isLoadingMore.value }])
                                  }, null, 2)
                                ], 8, _hoisted_10))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_14, 8, _hoisted_12)
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})